import React from 'react';

const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <g clipPath="url(#clip0_12270_29942)">
      <path
        d="M9.5 17.25C14.0563 17.25 17.75 13.5563 17.75 9.00002C17.75 4.44365 14.0563 0.75 9.5 0.75C4.94365 0.75 1.25 4.44365 1.25 9.00002C1.25 13.5563 4.94365 17.25 9.5 17.25Z"
        stroke="#4B4B4B"
      />
      <path
        d="M11.375 12.7539H10.25C10.0511 12.7539 9.8603 12.6749 9.71968 12.5342C9.57905 12.3936 9.5 12.2028 9.5 12.0039V7.12891C9.5 7.02946 9.46047 6.93407 9.3902 6.86374C9.31985 6.79342 9.22445 6.75391 9.125 6.75391H8"
        stroke="#4B4B4B"
      />
      <path
        d="M9.30603 5.25C9.20246 5.25 9.11853 5.16605 9.11853 5.0625C9.11853 4.95895 9.20246 4.875 9.30603 4.875"
        stroke="#4B4B4B"
      />
      <path
        d="M9.30603 5.25C9.40953 5.25 9.49353 5.16605 9.49353 5.0625C9.49353 4.95895 9.40953 4.875 9.30603 4.875"
        stroke="#4B4B4B"
      />
    </g>
    <defs>
      <clipPath id="clip0_12270_29942">
        <rect width="18" height="18" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoIcon;
